import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface ReplyQuestionPayload {
  productId: string;
  body: any;
  withFiles?: boolean;
  clarificationId: string;
}

const replyQuestion = async (payload: ReplyQuestionPayload): Promise<any> => {
  try {
    const { data } = await apiService.post<any>(
      `/clarifications/${payload.clarificationId}/replies/`,
      payload.body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const useReplyQuestion = () => {
  const queryClient = useQueryClient();
  const id = useAuthStore((state) => state.user?.id);

  return useMutation({
    mutationFn: async (payload: ReplyQuestionPayload) => {
      return await replyQuestion(payload);
    },
    onSuccess: async (_data, variables) => {
      if (!variables.withFiles) {
        queryClient.invalidateQueries({
          queryKey: ['product-updates', id, variables.productId]
        });
      }
    }
  });
};
